import { Component, Input } from '@angular/core';
import { AbstractControl, FormArray, FormGroup } from '@angular/forms';
import { massValidationMessage } from './data-entity-mass-form.validators';

@Component({
  selector: 'app-data-entity-mass-weight-input',
  templateUrl: './DataEntityMassWeightInput.component.html',
  styleUrls: ['./DataEntityMassWeightInput.component.scss']
})
export class DataEntityMassWeightInputComponent {
  @Input() group: FormGroup;
  @Input() standards: any[] = [];
  readonly constants = ['Upa', 'Pr', 'P0', 'Pal', 'Upr', 'Pt', 'PaInd', 'TaInd', 'QaInd'];
  readonly rectangular = ['Upt', 'Dsensitivity', 'Dresolution', 'Deccentricity', 'PaRes', 'TaRes', 'QRes'];
  readonly expanded = ['PaCal', 'TaCal', 'QCal'];
  get items(): FormArray { return this.group.get('Items') as FormArray; }
  asGroup(control: any): FormGroup { return control as FormGroup; }
  hasCompatibilityUncertainty(item: AbstractControl): boolean { return item.get('MsnUncertainty') instanceof FormGroup; }
  validationMessage(control: AbstractControl): string { return massValidationMessage(control); }
}
